import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {EventsParams} from '../models/events';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class EventsService {

  constructor(private http: HttpClient) { }

  getDevicesEvents(params): Observable<any> {
    const startDate = params.startDate.getTime() / 1000;
    const endDate = params.endDate.getTime() / 1000;
    const param = (params.RegionIds) ?
     { otp: params.otp, startDate: startDate, endDate: endDate, dcode: params.dcode, RegionIds: params.RegionIds } :
     { otp: params.otp, startDate: startDate, endDate: endDate, dcode: params.dcode };
    return this.http.post<any>(`${environment.apiIotUrl}/events/read`, param);
    // return this.http.post<any>(`${environment.apiIotUrl}/web_events`,
    //   { otp: params.otp, startDate: startDate, endDate: endDate});
  }

  getEventMaps(otp): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/event/enum/read/all`, {otp: otp});
  }

  ReadEventByAdmin(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/admin/events/read`, params);
  }

  getHardwareFaultLevelMaps(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/hardwarefault/level/read/all`, params);
  }

  getHardwareFaultCodeMaps(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/hardwarefault/code/read/all`, params);
  }
}

